export default "__VITE_ASSET__a978f3a5__"